import React from 'react';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import FsCaption from 'ui-elements/typography/FsCaption';
import { TypographyAllProps } from 'globals/types';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';

export const ContainerBox = withStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
}))((props: BoxProps) => {
  return <Box {...props} />;
});

export const Caption = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    color: palette.grey[400],
    margin: spacing(2, 0),
  },
}))((props: TypographyAllProps) => <FsCaption component="h5" {...props} />);

export const Paragraph = withStyles(
  {}
)((props: TypographyAllProps & { component?: string }) => (
  <FsBodySmall {...props} />
));
